export function customStepValidation(currentIndex: number) {
    const content = document.querySelector(`.step-content[data-step="${currentIndex}"]`);

    if (!content) return false;

    switch (currentIndex) {
        case 0:
            return validateFairSelectionStp(currentIndex);
        case 1:
            return true;
        default:
            return true;
    }
}

function validateFairSelectionStp(currentIndex: number) {
    const content = document.querySelector(`.step-content[data-step="${currentIndex}"]`);
    const valid = Array.from(content.querySelectorAll('.sta-fairs-table input.fair-amount')).some((el: HTMLInputElement) => {
        return parseInt(el.value) > 0;
    });
    if (!valid) {
        document.toast.init('Ungültige Eingabe', 'Bitte wählen Sie mindestens eine Karrieremesse aus, um fortzufahren.', 'error')
    }
    return valid;
}